// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cPiB","input":"styles_input__A8tkx"};